import React from "react";
import { Link } from "react-router-dom";

import bg1 from '../../assets/images/bg/bg-career.jpg'
import job1 from '../../assets/images/job/1.jpg'
import testi from '../../assets/images/bg/testi.jpg'

import Navbar from "../../components/navbar";
import PricingTwo from "../../components/pricingTwo";
import Blog from "../../components/blog";
import Footer from "../../components/footer";
import ScrollTop from "../../components/scrollTop";
import FooterTopTwo from "../../components/footerTopTwo";

import { categories, clientData, companyAbout, featuredCompany, jobData } from "../../data/data";

import { FiMapPin, FiArrowRight, MdOutlineCheckCircle } from '../../assets/icons/icons'

import TinySlider from "tiny-slider-react";
import 'tiny-slider/dist/tiny-slider.css';

export default function IndexCareer(){
    let settings = {
        container: '.tiny-single-item',
        items: 1,
        controls: false,
        mouseDrag: true,
        loop: true,
        rewind: true,
        autoplay: true,
        autoplayButtonOutput: false,
        autoplayTimeout: 3000,
        navPosition: "bottom",
        speed: 400,
        gutter: 16,
      };
    return(
        <>
        <Navbar navLight={true}/>

        <section className="bg-half-260 d-table w-100" style={{backgroundImage:`url(${bg1})`, backgroundPosition:'center'}}>
            <div className="bg-overlay"></div>
            <div className="container">
                <div className="row justify-content-center mt-5">
                    <div className="col-lg-10">
                        <div className="heading-title text-center">
                            <h4 className="heading text-light title-dark mb-3">Find Your Dream Job !</h4>
                            <p className="para-desc mx-auto text-white-50">Explore and learn more about everything from machine learning and global payments to  scaling your team.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section className="section pb-0">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-10">
                        <div className="features-absolute career-form bg-white p-4 rounded shadow">
                            <form>
                                <div className="row text-start">
                                    <div className="col-lg-4 col-md-4">
                                        <div className="mb-0">
                                            <input type="text" className="form-control" required placeholder="Keywords"/>
                                        </div>
                                    </div>
                                    
                                    <div className="col-lg-8 col-md-8">
                                        <div className="row align-items-center">
                                            <div className="col-md-4 mt-4 mt-sm-0">
                                                <div className="mb-0">
                                                    <select className="form-select form-control">
                                                        <option defaultValue="">Location</option>
                                                        <option defaultValue="AF">Afghanistan</option>
                                                        <option defaultValue="AX">&Aring;land Islands</option>
                                                        <option defaultValue="AL">Albania</option>
                                                        <option defaultValue="DZ">Algeria</option>
                                                        <option defaultValue="AS">American Samoa</option>
                                                        <option defaultValue="AD">Andorra</option>
                                                        <option defaultValue="AO">Angola</option>
                                                        <option defaultValue="AI">Anguilla</option>
                                                        <option defaultValue="AQ">Antarctica</option>
                                                    </select>
                                                </div>
                                            </div>
                                            
                                            <div className="col-md-4 mt-4 mt-sm-0">
                                                <div className="mb-0">
                                                    <select className="form-select form-control">
                                                        <option defaultValue="">Job Types</option>
                                                        <option defaultValue="4">Accounting</option>
                                                        <option defaultValue="1">IT & Software</option>
                                                        <option defaultValue="3">Marketing</option>
                                                        <option defaultValue="5">Banking</option>
                                                    </select>
                                                </div>
                                            </div>

                                            <div className="col-md-4 mt-4 mt-sm-0">
                                                <div className="d-grid">
                                                    <input type="submit" id="search" name="search" className="searchbtn btn btn-primary" defaultValue="Search"/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section className="section pt-md-4">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-12">
                        <div className="section-title text-center mb-4 pb-2">
                            <h6 className="text-primary">New Openings</h6>
                            <h4 className="title mb-4">Popular Categories</h4>
                            <p className="text-muted para-desc mx-auto mb-0">Explore and learn more about everything from machine learning and global payments to  scaling your team.</p>
                        </div>
                    </div>
                </div>

                <div className="row">
                    {categories.map(( item, index ) =>{
                        let Icon = item.icon
                        return(
                            <div className="col-lg-3 col-md-4 col-12 mt-4 pt-2" key={index}>
                                <Link to="#" className="job-catagories bg-catagory-primary position-relative overflow-hidden rounded d-block shadow p-4">
                                    <h5 className="mb-0 title text-dark">{item.title}</h5>
                                    <small className="text-muted sub-title">{item.name}</small>
                                    <div className="icons text-dark h2 mb-0">
                                        <Icon/>
                                    </div>
                                </Link>
                            </div>
                        )
                    })}
                </div>
            </div>

            <div className="container mt-100 mt-60">
                <div className="row justify-content-center">
                    <div className="col-12">
                        <div className="section-title text-center mb-4 pb-2">
                            <h6 className="text-primary">Brands</h6>
                            <h4 className="title mb-4">Featured Companies</h4>
                            <p className="text-muted para-desc mx-auto mb-0">Explore and learn more about everything from machine learning and global payments to  scaling your team.</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container-fluid">
                <div className="row">
                    {featuredCompany.map((item, index) =>{
                        return(
                            <div className="col-lg-2 col-md-4 col-12 mt-4 pt-2" key={index}>
                                <Link to="#" className="feature-company rounded d-block text-center shadow p-4">
                                    <img src={item.image} className="avatar avatar-md-md" alt=""/>
                                    <div className="content mt-4">
                                        <h5 className="company-name text-dark mb-0">{item.title}</h5>
                                        <p className="text-muted mb-0"><FiMapPin className="me-1"/>{item.location}</p>
                                        <small className="text-muted sub-title">{item.vacancy}</small>
                                    </div>
                                </Link>
                            </div>
                        )
                    })}
                </div>

                <div className="row mt-4 pt-2">
                    <div className="col-12 text-center">
                        <Link to="#" className="btn btn-primary">See All Companies <FiArrowRight className="fea icon-sm"/></Link>
                    </div>
                </div>
            </div>

            <div className="container mt-100 mt-60">
                <div className="row align-items-center">
                    <div className="col-md-6">
                        <img src={job1} className="img-fluid shadow rounded" alt=""/>
                    </div>

                    <div className="col-md-6 mt-4 pt-2 mt-sm-0 pt-sm-0">
                        <div className="section-title ms-lg-5">
                            <h6 className="text-primary">Come Join us</h6>
                            <h4 className="title mb-4">Why Work Here</h4>
                            <p className="text-muted para-desc">Explore and learn more about everything from machine learning and global payments to  scaling your team.</p>
                        
                            <ul className="list-unstyled mb-0">
                                {companyAbout.map((item, index) =>{
                                    return(
                                        <li className="list-inline-item mt-4 me-lg-5 me-4" key={index}>
                                            <div className="d-flex">
                                                <span className="text-primary h4 me-2"><MdOutlineCheckCircle className="align-middle"/></span>
                                                <div className="flex-1">
                                                    <h4 className="mb-0">{item.number}</h4>
                                                    <h6 className="mb-0 text-muted">{item.title}</h6>
                                                </div>
                                            </div>
                                        </li>
                                    )
                                })}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container mt-100 mt-60">
                <div className="row justify-content-center">
                    <div className="col-lg-10">
                        <div className="row align-items-center mb-4 pb-2">
                            <div className="col-lg-9 col-md-8">
                                <div className="section-title">
                                    <h6 className="text-primary">Vacancy</h6>
                                    <h4 className="title mb-4">Latest Job or Vacancy list</h4>
                                    <p className="text-muted para-desc mb-0">Explore and learn more about everything from machine learning and global payments to  scaling your team.</p>
                                </div>
                            </div>
        
                            <div className="col-lg-3 col-md-4 mt-4 mt-sm-0 pt-2 pt-sm-0">
                                <div className="form custom-form">
                                    <div className="mb-0">
                                        <label className="form-label">Types of jobs :</label>
                                        <select className="form-control form-select" id="Sortbylist-job">
                                            <option>All Jobs</option>
                                            <option>Full Time</option>
                                            <option>Part Time</option>
                                            <option>Remote</option>
                                            <option>Work From Home</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row justify-content-center">
                    <div className="col-lg-10 mt-4 pt-2">
                        <ul className="list-unstyled mb-0">
                            {jobData.map((item, index) =>{
                                return(
                                    <li className="mt-3" key={index}>
                                        <Link to={`/career-detail/${item.id}`} className="d-flex job-vacancy job-primary align-items-center justify-content-between p-4 shadow rounded">
                                            <div className="content">
                                                <h5 className="text-dark job-caragory">{item.job}</h5>
                                                <p className="text-muted mb-0">{item.location}</p>
                                            </div>
                                            <FiArrowRight className="fea icon-ex-md text-dark icon"/>
                                        </Link>
                                    </li>
                                )
                            })}
                        </ul>
                    </div>
                </div>
            </div>

            <div className="container-fluid mt-100 mt-60">
                <div className="py-5 rounded" style={{backgroundImage:`url(${testi})`}}>
                    <div className="container">
                        <div className="row py-md-5 py-4">
                            <div className="col-lg-4 col-md-6">
                                <div className="bg-white rounded px-4 py-5">
                                    <div className="tiny-single-item">
                                        <TinySlider settings={settings}>
                                            {clientData.map((item, index) =>{
                                                return(
                                                <div className="tiny-slide" key={index}>
                                                    <div className="customer-testi">
                                                        <p className="text-muted fst-italic">{item.desc}</p>
                                                        <div className="d-flex align-items-center mt-4">
                                                            <img src={item.image} className="img-fluid avatar avatar-small rounded-circle shadow" alt=""/>
                                                            <div className="flex-1 ms-3">
                                                                <h6 className="text-primary mb-0">{item.name}</h6>
                                                                <small className="text-muted">{item.title}</small>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                )
                                            })}
                                        </TinySlider>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container mt-100 mt-60">
                <PricingTwo bgColor="card pricing border-0 p-4 rounded-md shadow bg-primary"/>
            </div>

            <div className="container mt-100 mt-60">
                <div className="row justify-content-center">
                    <div className="col-12">
                        <div className="section-title text-center mb-4 pb-2">
                            <h6 className="text-primary">News</h6>
                            <h4 className="title mb-4">Latest News or Blogs</h4>
                            <p className="text-muted para-desc mx-auto mb-0">Explore and learn more about everything from machine learning and global payments to  scaling your team.</p>
                        </div>
                    </div>
                </div>

                <Blog/>
            </div>
        </section>
        <FooterTopTwo/>
        <Footer/>
        <ScrollTop/>
        </>
    )
}